import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const StyledInput = styled.div`
    position: relative;
    margin-bottom: 28px;
    vertical-align: middle;

    label {
        display: flex;
        font-size: 16px;
        color: #757575;
    }

    input {
        opacity: 0 !important;
        border: none !important;
        height: 0;
        overflow: hidden;
        padding: 0;
        position: absolute;
        white-space: nowrap;
        width: 0;
    }

    .required-indicator {
        position: absolute;
        right: 0;
        top: 0;
        width: 6px;
        height: 56px;
        background-color: ${props =>
            props.hasError
                ? props.theme.colors.error
                : props.theme.colors.primaryYellow};
        transition: background-color 0.2s;
    }

    p {
        font-size: 12px;
        color: ${props => props.theme.colors.error};
        line-height: 14px;
        left: 8px;
        padding-top: 5px;
        position: absolute;
    }

    .custom-checkbox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        background-color: ${props =>
            props.isChecked
                ? props.theme.colors.primaryYellow
                : props.theme.colors.white};
        box-sizing: border-box;
        margin-right: 16px;
        border-radius: 3px;
        border: 1px solid
            ${props =>
                props.isChecked
                    ? props.theme.colors.primaryYellow
                    : props.theme.colors.lightGray};
        svg {
            margin-left: 1px;
        }
    }
    span {
        color: ${props => props.theme.colors.error};
    }

    .checkbox__label-text {
        flex: 1;
    }
`;

const variants = {
    hasError: {
        border: '1px solid #cf0a2c',
        opacity: 1,
    },
    valid: { border: '1px solid #b5b5b5', opacity: 1 },
};
const ErrorVariants = {
    show: { opacity: 1 },
    hide: { opacity: 0 },
};
function HookFormCheckbox({
    className,
    hasError,
    errorText,
    label,
    register,
    name,
    required,
    checked,
    onChange,
    defaultChecked,
}) {
    //These are used to drive the various Framer Motion animation states for the input
    const [hasValue, setHasValue] = useState(
        checked ? true : defaultChecked ? true : false
    );
    const [isChecked, setIsChecked] = useState(checked);
    var ValidationRules = {};
    if (required) {
        ValidationRules.required = {
            value: required,
            message: `This is required.`,
        };
    }
    return (
        <StyledInput
            isChecked={isChecked}
            className={className}
            hasError={hasError}
            required={required}
            hasValue={hasValue}
        >
            <label className="checkbox-label" htmlFor={name}>
                <div className="custom-checkbox">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                    >
                        <motion.path
                            id="Path_1"
                            data-name="Path 1"
                            d="M5.656,11.518l4.363,4.244,8.313-8.133"
                            transform="translate(-4.959 -6.914)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="2"
                            animate={{ pathLength: hasValue ? 1 : 0 }}
                            initial={false}
                        />
                    </svg>
                </div>
                <motion.input
                    type="checkbox"
                    name={name}
                    ref={register(ValidationRules)}
                    defaultChecked={checked ? true : false}
                    animate={hasError ? 'hasError' : 'valid'}
                    initial={{ opacity: 0 }}
                    variants={variants}
                    onChange={e => {
                        setHasValue(e.target.checked ? true : false);
                        setIsChecked(!isChecked);
                        onChange(e);
                    }}
                    id={name}
                ></motion.input>
                <span
                    initial={{ opacity: 0 }}
                    variants={ErrorVariants}
                    animate={hasError ? 'show' : 'hide'}
                >
                    {errorText}
                </span>{' '}
                <div className="checkbox__label-text">{label}</div>
            </label>
        </StyledInput>
    );
}

HookFormCheckbox.propTypes = {
    className: PropTypes.string,
};

HookFormCheckbox.defaultProps = {};

export default HookFormCheckbox;
